import type { SyntheticEvent } from 'react';
import { FieldPath, UseFormReturn } from 'react-hook-form';
import { Select, SelectProps } from '@chakra-ui/react';

type SelectInputProps<TFieldValues> = SelectProps & {
  name: FieldPath<TFieldValues>;
  list: { id: number | string | undefined; name: string }[];
  register: UseFormReturn<TFieldValues>['register'];
  onChange: (e: SyntheticEvent<HTMLSelectElement>) => void;
};

/**
 * リリースタスク登録・変更画面の`ターゲットグループ`項目です。
 */
export const SelectTargetGroupInput = <TFieldValues,>({
  name,
  list,
  register,
  onChange,
}: SelectInputProps<TFieldValues>) => (
  <Select
    {...register(name, {
      required: '必須項目です。',
      onChange,
    })}
  >
    {list.map((component) => (
      <option key={component.id} value={component.id}>
        {component.name}
      </option>
    ))}
  </Select>
);
